import * as React from 'react'
import * as styles from './Pagination.module.scss'
import { Button, Spinner } from 'DVWebNodeUI'
import * as cn from 'classnames'
import InView from 'react-intersection-observer'
import checkUrlType from '../utils/url-type-checker'
import { StorefrontPagination as PaginationOutput } from 'DVWebNodeUtils';

const TRIGGER_VERTICAL_MARGIN = 1000

export interface PaginationProps extends PaginationOutput {
  isLoading?: boolean
  loadMoreContent?: Function
  url: string
}

const Pagination = (props: PaginationProps) => {
  if (!props || !props.label) {
    return null
  }
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    props.loadMoreContent()
  }
  const rootMargin = `${TRIGGER_VERTICAL_MARGIN}px 0px ${TRIGGER_VERTICAL_MARGIN}px 0px`
  const content = props.isLoading ? (
    <div className={cn(styles.PaginationWrapper, 'tst-pagination-loader')}>
      <Spinner />
    </div>
  ) : (
      <div className={styles.PaginationWrapper}>
        <a
          className={cn(styles.Pagination, 'tst-pagination')}
          href={checkUrlType(props.url, 'Pagination')}
          onClick={handleClick}
        >
          <Button className={styles.PaginationContent}>
            {props.label}
          </Button>
        </a>
      </div>)
  return (global.__SERVER__ && !global.__DEVSERVER__ ? content :
    <InView
      rootMargin={rootMargin}
      onChange={inView => inView && props.loadMoreContent()}
    >
      {content}
    </InView>
  )
}

export default Pagination
